import { render } from "./PaymentTypeAdd.vue?vue&type=template&id=be9dc1ea"
import script from "./PaymentTypeAdd.vue?vue&type=script&lang=js"
export * from "./PaymentTypeAdd.vue?vue&type=script&lang=js"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__